//Ebook data page where all data stored in object form

const EbookData= [
    {id:1,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5ff357de7135007e99490168_ebook_1.jpg",
     detail:"The Definitive Guide to running Your Marketing Team in 2018 ",
     page:"27 Pages"
   
 },
 {id:2,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5ff357af02956aa64936df2e_ebook_2.png",
     detail:"Supercharge your content AND save Time and money",
     page:"24 Pages"
 },]
 export default EbookData
